import React from 'react';
import './index.sass';

export default function Product({
  alignRight = true,
  img = '',
  tipImg = '',
}) {
  const poster = <img src={alignRight ? img : tipImg} className={alignRight ? 'product-poster' : 'info-box'} alt='img' />;
  const tipBox = <img src={!alignRight ? img : tipImg} className={!alignRight ? 'product-poster' : 'info-box'} alt='img' />;
  return (
    <div className='product-holder'>
      {poster}
      {tipBox}
    </div>
  );
}
